export default "__VITE_ASSET__ChF980oi__"